import Vue from "vue";
import "./plugins/axios";
import "./plugins/vuetify";
import "./plugins/vue-google-maps";

import app from "./App.vue";
import router from "./router";
import store from "./store/store";
import i18n from "./i18n";
import vuetify from "@/plugins/vuetify";
import konva from "vue-konva";

import preview from "./components/Player/Preview.vue";

import "@koas/v-hscroll";

Vue.use(konva);
Vue.use(vuetify);

Vue.component("preview", preview);

new Vue({
  render: (h) => h(app),
  vuetify,
  router,
  store,
  i18n,
}).$mount("#app");
